import * as Yup from "yup";

const loginSchema = {};

loginSchema.validateLogin = () => {
  return Yup.object({
    mobile: Yup.string()
      .required("Mobile no is required.")
      .min(9, "Mobile no should be at least 9 characters.")
      .max(15, "Mobile no should be at most 15 characters."),
    country: Yup.string().required("Country Code is required."),
  });
};

loginSchema.validateOtp = () => {
  return Yup.object({
    otp: Yup.array()
      .min(4, "PIN should be at least 4 characters.")
      .max(4, "PIN should be at most 4 characters."),
  });
};
// loginSchema.validateLoginPinBased = () => {
//   return Yup.object({
//     mobile: Yup.string()
//       .required("Mobile no is required.")
//       .min(9, "Mobile no should be at least 9 characters.")
//       .max(15, "Mobile no should be at most 15 characters."),
//     country: Yup.string().required("Country Code is required."),
//     pin: Yup.array()
//       .min(4, "PIN should be at least 4 characters.")
//       .max(4, "PIN should be at most 4 characters."),
//   });
// };
export default loginSchema;
